// extracted by mini-css-extract-plugin
export default {"container":"KCgyk","button":"xi42L","actionsContainer":"Lp0vb","center":"lE9L2","right":"EqRax","top":"c4Hq0","triangle":"bQHXI","fixedColor":"AdFtG"};